/// <amd-module name="Environments/EnvironmentsSecurity/Common/Utils" />
import { PageContextHelper } from "Environments/Client/PageContextHelper";
import { EnvironmentRoleScopes, EnvironmentSecurityDialogConstants} from "Environments/EnvironmentsSecurity/Constants";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";

export class PageKey {
    public static EnvironmentsSecurityView = "environment-security";
}

export function getScopeId(pageContext: IVssPageContext, environmentId: number | undefined): string {
    const projectId = PageContextHelper.getProjectId(pageContext);
    const inProjectContext: boolean = !!projectId;
    const hasEnvironmentId: boolean = !!environmentId && environmentId > 0;

    if (inProjectContext && hasEnvironmentId) {
        return EnvironmentRoleScopes.EnvironmentReferenceRoleScopeId;
    }

    if (inProjectContext && !hasEnvironmentId) {
        return EnvironmentRoleScopes.GlobalEnvironmentReferenceRoleScopeId;
    }

    if (!inProjectContext && hasEnvironmentId) {
        return EnvironmentRoleScopes.EnvironmentRoleScopeId;
    }
    
    return EnvironmentRoleScopes.GlobalEnvironmentRoleScopeId;
}

export function getResourceId(pageContext: IVssPageContext, environmentId: number | undefined): string {
    const projectId: string | undefined = PageContextHelper.getProjectId(pageContext);
    const environmentIdString  = environmentId ? environmentId.toString() : "";
    const inProjectContext: boolean = !!projectId;
    const hasEnvironmentId: boolean = !!environmentIdString;

    if (inProjectContext && hasEnvironmentId) {
        return format("{0}{1}{2}",
         projectId,
         EnvironmentSecurityDialogConstants.ReplaceableTokenSeperator,
         environmentId);
    }

    if (inProjectContext) {
        return projectId || "";
    }

    if (hasEnvironmentId) {
        return environmentIdString;
    }

    return "";
}

export const Area = "EnvironmentDeployment";

export namespace FeatureNames {
    export const EnvironmentSecurityView = "EnvironmentSecurityView";
}